module.exports = __webpack_public_path__ + "static/media/logo.bed46c5e.png";